/**
 * Enum of import modes used to import text and CSV files.
 */
export enum ImportMode {
  Insert = 'insert',
  Overwrite = 'overwrite'
}
